/* eslint-disable no-unused-vars */
import { Button } from "components/Common/button";

import Text from "components/Common/Text";

import { motion } from "framer-motion";
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import "./styles.css";
import { Header } from "components/Common/Header";
import { WeatherWidget } from "./weather";

function Landing() {
  const navigate = useNavigate();

  const [isFlipped, setIsFlipped] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFlipped((prev) => !prev);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        // position: "fixed",
        top: 0,
        left: 0,
        height: "100dvh", // Используем 100dvh вместо 100vh
        // width: "100vw",
        backgroundImage:
          "linear-gradient(to bottom, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.8) 90%), url(https://bergingolf.com/wp-content/uploads/2015/03/Mob2.jpg)",
        backgroundSize: "cover",
        // backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          flex: 1,
        }}
      >
        <div style={{ width: "100%" }}>
          <Header hideQr />
        </div>
        <div
          style={{
            margin: "auto",
            display: "flex",
          }}
        >
          <motion.img
            src="https://kecamps.com/_media/camp_logos/mobile_logo.png"
            alt="The Big Game"
            className="createEvent-logo"
            style={{
              width: "10rem",
              height: "auto",

              opacity: 0.8,
            }}
            animate={{
              rotateY: isFlipped ? 180 : 0,
            }}
            transition={{
              duration: 1,
              ease: "easeInOut",
            }}
          />
        </div>
      </div>
      <div
        style={{
          padding: "0px 16px",
          width: "100%",
          marginBottom: "env(safe-area-inset-bottom)", // Учитываем вырез iPhone
        }}
      >
        <WeatherWidget />
        <Text as="H1" bold mt={10}>
          The Big Game
        </Text>
        <Text as="P1" bold mt={0}>
          The Country Club of Mobile
        </Text>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 16,
            marginBottom: 26,
          }}
        >
          <button
            onClick={() => navigate("/dogpound")}
            type="button"
            style={{
              backgroundColor: "#22C17B",
              width: "100%",
              color: "white",
              border: "none",
              padding: "10px 20px",
              borderRadius: "8px",
              fontSize: "16px",
              marginRight: "10px",
            }}
          >
            Dogs: Enter The Dog Pound
          </button>
          <button
            onClick={() => navigate("/create")}
            type="button"
            style={{
              backgroundColor: "transparent",
              width: "100%",
              color: "white",
              border: "1px solid white",
              padding: "10px 20px",
              borderRadius: "8px",
              fontSize: "16px",
            }}
          >
            2 Man/3 Man Only
          </button>
        </div>
      </div>
    </div>
  );
}

export { Landing };
